import { Component, OnInit } from "@angular/core";
import { SharedDataService } from "../shared-data.service";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";

@Component({
  selector: "app-dashboards-tab",
  imports: [CommonModule, RouterModule],
  templateUrl: "./dashboards-tab.component.html",
  styleUrl: "./dashboards-tab.component.scss",
})
export class DashboardsTabComponent implements OnInit {
  data: any;
  constructor(private sharedDataService: SharedDataService) {}

  ngOnInit() {
    this.data = this.sharedDataService.data;
  }
}
